import MenuItem from "./menuItem/MenuItem";
import SubMenu from "./subMenu/SubMenu";
import styles from "./menu.module.scss";
import type { IMenu } from "../../../constants";

interface MenuProps {
  menuItems: IMenu[];
  onCloseDrawer?: (() => void) | undefined;
}

const Menu = (props: MenuProps) => {
  const { menuItems, onCloseDrawer } = props;

  return (
    <nav className={styles["menu"]}>
      {menuItems?.map((item) => {
        if (item?.childs) {
          return (
            <SubMenu
              key={`sub-menu-${item.linkID}`}
              menuItem={item}
              onCloseDrawer={onCloseDrawer}
            />
          );
        } else {
          return <MenuItem key={`menu-item-${item.linkID}`} menuItem={item} />;
        }
      })}
    </nav>
  );
};

export default Menu;
